import Locations from "./Locations";
import './locations.scss';

export default Locations;